
define('text!views/home/index.html',[],function () { return '<div class="well">\r\n    <div class="jumbotron">\r\n        <h1>Index</h1>\r\n    </div>\r\n</div>';});

